module.exports = __webpack_public_path__ + "assets/1861c947fb02cc3ce3f8d909b7914d33.svg";